/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addReferenceableSyncEntity} from '../api'

export const useMutationAddReferenceableSyncEntity = createReactQueryMutationHook('addReferenceableSyncEntity', addReferenceableSyncEntity)
